<nav>
    <ol>
        @for (item of navigation(); track $index) {
        <li>
            <immo-navigation-item [item]="item" [isExpanded]="isExpanded()" [withIcon]="withIcons()" />

            @if (!$last) {
            <hr class="my-1.5 border-on-sidebar/10" />
            }
        </li>
        }
    </ol>
</nav>